import { render, staticRenderFns } from "./PaperQualityReview.vue?vue&type=template&id=8338918a&scoped=true"
import script from "./PaperQualityReview.vue?vue&type=script&lang=js"
export * from "./PaperQualityReview.vue?vue&type=script&lang=js"
import style0 from "./PaperQualityReview.vue?vue&type=style&index=0&id=8338918a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8338918a",
  null
  
)

export default component.exports